import React from 'react';
import NewsCard from './NewsCard';
const NewsListItem = ({ item }) => <NewsCard data={item} forList/>;
export default NewsListItem;
